<template>
  <div v-if="activeBanner" class="app-banner">
    <SubscriptionStatusBanner v-if="activeBanner === 'subscription'" />
    <CreditWarningBanner v-else-if="activeBanner === 'credit'" />
    <FreeTryPlanBanner v-else-if="activeBanner === 'freeTry'" />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { storeToRefs } from 'pinia'
import { useTenantsStore } from '@/stores/tenants'
import { useBillingStore } from '@/stores/billing'
import { TenantPlan, isCreditPlan } from '@/models/Tenant'
import SubscriptionStatusBanner from '@/components/shared/SubscriptionStatusBanner.vue'
import CreditWarningBanner from '@/components/shared/CreditWarningBanner.vue'
import FreeTryPlanBanner from '@/components/shared/FreeTryPlanBanner.vue'

const tenantsStore = useTenantsStore()
const billingStore = useBillingStore()
const { subscriptionStatusInfo } = storeToRefs(tenantsStore)
const { isLowBalance } = storeToRefs(billingStore)

const activeBanner = computed(() => {
  if (subscriptionStatusInfo.value?.requiresAttention) return 'subscription'

  const plan = tenantsStore.currentTenant?.plan
  if (plan && isCreditPlan(plan) && isLowBalance.value) return 'credit'
  if (plan === TenantPlan.FREE_TRY) return 'freeTry'

  return null
})
</script>

<style scoped>
.app-banner :deep(.p-message) {
  border-radius: 0;
  margin: 0;
}

.app-banner :deep(.p-message-content) {
  padding-left: 1rem;
  padding-right: 1rem;
}
</style>
